<template>
	<div class="tpl tree-hole-wrap">
		<mt-header title="树洞详情" fixed>
			<router-link :to="{name:'trends',query:{'selected':selected}}" slot="left">
				<mt-button icon="back"></mt-button>
			</router-link>
		</mt-header>
		<div class="item-content">
			<div class="item-user">
				<div class="item-user-info">
					<div class="item-user-img">
						<img src="../../assets/img/trends/dyn_tree_ic_anony.png"/> 
					</div>
					<div class="item-user-text">
						<p class="user-name">
							匿名用户
						</p>
						<p class="user-related">
							<span>发布于{{treeInfo.create_time | toDateTime | convertTime("YYYY.MM.DD")}}</span>&nbsp;
							<span>{{treeInfo.views}}人浏览过</span>
						</p>
					</div>
				</div>
				<div class="item-option" v-if="treeInfo.anonymous_chat==1">
					<!--<button>私聊</button>-->
				</div>
			</div>
			<p class="item-title">{{treeInfo.title}}</p>
			<div class="item-text">
				<p>{{treeInfo.text}}</p>
			</div>
		</div>
		<div class="tree-options">
			<tree-option 
				:uid="uid" 
				:did="tid" 
				:oid="treeInfo.t_uid"
				:isComment="treeInfo.open_comment"
				:nums="nums"
				@refreshData="getTreeInfo"
				></tree-option>
		</div>
	</div>
</template>

<script>
	import TreeOption from "./TreeDetailOptions"
	
	export default{
		name:"tree-hole-detail",
		components:{
			TreeOption
		},
		data(){
			return{
				uid:"",
				tid:"",
				selected:"",
				treeInfo:"",
				nums:{}
			}
		},
		created(){
			this.uid = this.$store.state.UserId; //获取当前用户的id
			this.$store.commit("changeTabChoosed", "trends");
			this.$store.commit("changeTabBarShow", false);
			
			this.tid = this.$route.query.id;
			this.selected = this.$route.query.selected;
			
			this.getTreeInfo();
		},
		methods:{
			getTreeInfo(){
				this.$axios({
					url:"Dynamic/TreeHoleDetails",
					method:"post",
					data:{
						uid:this.uid,
						t_id:this.tid
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.treeInfo = res.data.data;
						this.nums={
							rNum:this.treeInfo.reward,
							cNum:this.treeInfo.comment,
							gNum:this.treeInfo.good
						}
					}
				}).catch(err=>{
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped>
	.tree-hole-wrap{
		padding: 3rem 1rem;
		background: #282828;
		min-height: 100vh;
	}
	>>>.mint-header{
		background: #282828 !important;
		border-color:#282828 !important;
	}
	>>>.mint-header .mint-header-title{
		color: #fff;
	}
	.tree-hole-wrap .item-content{
		padding: 1rem;
		background: #fff;
		border-radius: 5px;
		margin-bottom: 0.5rem;
	}
	.item-user{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.item-user-info{
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.item-user-info .item-user-img img{
		width: 3rem;
		display: block;
		border-radius: 4px;
	}
	.item-user-info .item-user-text{
		flex: 1;
		padding: 0 1rem;
	}
	.item-user-info .item-user-text .user-name{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 1rem;
		color: #282828;
		font-weight: bold;
	}
	.item-user-info .item-user-text .user-name img{
		width: 1.5rem;
	}
	.item-user-info .item-user-text .user-related{
		font-size: 0.8rem;
		color: #7b7b7b;
	}
	.item-option button{
		padding: 0.3rem 1rem;
		border-radius: 3rem;
		font-size: 0.8rem;
		color: #5415F9;
		border: 1px solid #5415F9;
		background: none;
		outline: 0;
		flex: 1;
	}
	.item-option button:active{
		background: #5415F9;
		color: #fff;
		opacity: 0.7;
	}
	.item-title{
		font-size: 1rem;
		color: #282828;
		line-height: 1.8rem;
		padding: 0.5rem 0;
		border-bottom: 1px solid #f3f3f3;
		font-weight: bold;
	}
	.item-text{
		font-size: 0.8rem;
		line-height: 1.2rem;
		color: #282828;
		padding: 0.8rem 0;
	}
	.item-related{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.item-related .item-tips span{
		margin-right: 0.5rem;
		font-size: 0.65rem;
		color: #9e9e9e;
	}
	.item-related .item-delete{
		color: #6D34FB;
		font-size: 0.8rem;
	}
	.tree-options{
		background: #fff;
		border-radius: 5px;
		overflow: hidden;
	}
</style>


// WEBPACK FOOTER //
// src/components/Trends/TreeHoleDetail.vue